import QuestionModelStatic from "../QuestionModelStatic";
import QuestionModule from "./QuestionModule";
import QuestionValue from "../QuestionValue";

export default class QuestionModuleStatic extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = new QuestionModelStatic(
            data.module,
            data.type,
            data.view,
            data.input,
            data.range,
            data.template || "generic/default",
            data.difficulty
        );

        data.option_1 && question.options.push(data.option_1);
        data.option_2 && question.options.push(data.option_2);
        data.option_3 && question.options.push(data.option_3);
        data.option_4 && question.options.push(data.option_4);

        question.values.push(new QuestionValue(data.result));
        question.options.push(new QuestionValue(data.result));
        P3.utils.shuffleArray(question.options);
        question.data = data;

        return question;
    }
}